import { Pipe, PipeTransform } from '@angular/core';
import { InstallationDurationPluginService } from './duration.service';
@Pipe({
    name: 'timeunits',
    standalone: false
})
export class TimeUnitsPipe implements PipeTransform {
  public timeUnits: any[];
  constructor(private service: InstallationDurationPluginService) {
    this.timeUnits = this.service.getTimeUnits();
  }
  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.timeUnits);
  }
}
